export const recordToString = (values: Record<string, string>) => (value: string) => values[value] || value;
